import { Model } from "pinia-orm";
import { Domain, CertipersUser } from "@/models";

export default class Role extends Model {
  static entity = "roles";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      userUuid: this.string(""),
      domainUuid: this.string(""),
      userData: this.belongsTo(CertipersUser, "userUuid"),
      domainData: this.belongsTo(Domain, "domainUuid"),
      roleType: this.string(""),
      status: this.string(""),
      certipersDocuments: this.attr([]),
      isDisplayed: this.boolean(true),
    };
  }
}
